import React from 'react';
import { HomeIcon, WrenchIcon, SearchIcon, CloudLightningIcon, BuildingIcon, HammerIcon } from 'lucide-react';
import { useModal } from '../App';
const services = [{
  title: 'Roof Replacement',
  description: 'Complete tear-off and installation with premium materials built to last 30+ years.',
  icon: HomeIcon
}, {
  title: 'Roof Repair',
  description: 'Fast, reliable repairs for leaks, missing shingles, and weather damage.',
  icon: WrenchIcon
}, {
  title: 'Roof Inspection',
  description: 'Thorough 21-point inspection with detailed report and honest recommendations.',
  icon: SearchIcon
}, {
  title: 'Storm Damage',
  description: 'Emergency storm response and insurance claim assistance when you need it most.',
  icon: CloudLightningIcon
}, {
  title: 'Commercial Roofing',
  description: 'Professional commercial roofing solutions for businesses of all sizes.',
  icon: BuildingIcon
}, {
  title: 'Roof Maintenance',
  description: 'Preventive maintenance programs to extend your roof life and prevent costly repairs.',
  icon: HammerIcon
}];
export function Services() {
  const {
    openModal
  } = useModal();
  return <section className="py-16 md:py-24 bg-background" data-id="element-282">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-283">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-284">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4" data-id="element-285">Our Roofing Services</h2>
          <p className="text-xl text-muted-foreground" data-id="element-286">Expert solutions for every roofing need</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-287">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} onClick={openModal} className="bg-card border border-border rounded-xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group cursor-pointer" data-id="element-288">
                <div className="mb-6 p-4 bg-amber-50 rounded-lg inline-block group-hover:bg-amber-100 transition-colors" data-id="element-289">
                  <Icon className="h-12 w-12 text-amber-500" data-id="element-290" />
                </div>
                <h3 className="text-2xl font-bold text-foreground mb-3" data-id="element-291">{service.title}</h3>
                <p className="text-muted-foreground leading-relaxed" data-id="element-292">{service.description}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}